import React from 'react';
import { Typography, Select, Card } from 'antd';
import { Button } from '../../ui';
import { BiPlus } from 'react-icons/bi';

const { Text } = Typography;
const { Option } = Select;

const TypeSelector = ({ 
  selectedType, 
  onTypeChange, 
  onChangeFinancialIndicators,
  types, 
  title = "Tipo de Classificação",
  subtitle = "Selecione o tipo de classificação para as categorias"
}) => {


  const selectedTypeObj = Object.values(types || {}).find(t => t.value === selectedType);
  return (
    <Card
      title={<span style={{ fontSize: 16, fontWeight: 600 }}>{title}</span>}
      style={{ marginBottom: 24 }}
    >
      <Text style={{ 
        display: 'block',
        marginBottom: 16,
        color: '#8c8c8c',
        fontSize: 14
      }}>
        {subtitle}
      </Text>
      

      <div style={{display: 'flex', alignItems: 'center',justifyContent: 'space-between', gap: 10, flexDirection: 'row'}}>
      <Select
        value={selectedType}
        onChange={onTypeChange}
        placeholder="Selecione o tipo"
        style={{ width: '100%', maxWidth: 400 }}
      >
        {Object.entries(types).map(([key, type]) => (
          <Option key={key} value={type.value}>
            {type.label}
          </Option>
        ))}
      </Select>
      </div>
    </Card>
  );
};

export default TypeSelector; 